/* Wishlist page — fills in the guest list from browser storage.
   Signed-in customers get their metafield-backed list rendered by Liquid; this
   only covers the guest case.

   Cards come back from Shopify so price, availability and image are always live.
   The section render is the primary path; if it returns something without a card
   in it, we fall back to the product JSON endpoint and build a minimal card by
   hand rather than leaving the page silently blank. */
(function () {
  'use strict';

  var Sloos = window.Sloos || {};

  function serverCards() {
    return document.querySelectorAll('.wishlist .grid-products:not([data-wishlist-grid]) .card').length;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  /* Last resort: the same classes the Liquid card uses, from the product JSON. */
  function cardFromJson(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    var price = Sloos.formatMoney ? Sloos.formatMoney(product.price) : '';
    var compare = product.compare_at_price;
    var onSale = compare && compare > product.price;

    var article = document.createElement('article');
    article.className = 'card card--grid';
    article.innerHTML =
      '<div class="card__media-wrap">' +
      '<a href="' + escapeHtml(product.url) + '" class="card__media media media--3-4">' +
      (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" class="card__image">' : '') +
      '</a>' +
      '<button type="button" class="card__wish is-active" data-wishlist-toggle="' + escapeHtml(product.handle) + '" aria-pressed="true">' +
      '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<path d="M10 17S3 12.6 3 7.9A3.9 3.9 0 0110 5.6 3.9 3.9 0 0117 7.9C17 12.6 10 17 10 17z" stroke="currentColor" stroke-width="1.2"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="card__info"><div class="card__row">' +
      '<h3 class="card__title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h3>' +
      '<div class="price' + (onSale ? ' price--on-sale' : '') + '">' +
      (onSale ? '<span class="price__was">' + escapeHtml(Sloos.formatMoney(compare)) + '</span>' : '') +
      '<span class="price__now">' + escapeHtml(price) + '</span>' +
      '</div></div></div>';
    return article;
  }

  function fetchCard(handle) {
    var base = (Sloos.routes && Sloos.routes.root ? Sloos.routes.root : '/') + 'products/' + encodeURIComponent(handle);

    return fetch(base + '?section_id=card-product')
      .then(function (response) {
        if (response.status === 404) {
          var gone = new Error('gone');
          gone.gone = true;
          throw gone;
        }
        if (!response.ok) throw new Error('section render failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-card-root] .card');
        if (card) return card;
        throw new Error('no card in section response');
      })
      .catch(function (error) {
        if (error.gone) throw error;

        console.warn('[wishlist] section render unusable for "' + handle + '" (' + error.message + '), falling back to product JSON');

        return fetch(base + '.js')
          .then(function (response) {
            if (!response.ok) {
              var gone = new Error('gone');
              gone.gone = true;
              throw gone;
            }
            return response.json();
          })
          .then(cardFromJson);
      });
  }

  var running = false;

  function render() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.getElementById('WishlistEmpty');
    if (!grid || !Sloos.wishlist || running) return;

    var handles = Sloos.wishlist.read();

    if (!handles.length) {
      grid.hidden = true;
      grid.innerHTML = '';
      if (empty) empty.hidden = serverCards() > 0;
      return;
    }

    running = true;
    grid.innerHTML = '';
    grid.hidden = false;
    if (empty) empty.hidden = true;

    /* Resolve every handle before touching the DOM, so the saved order is kept
       and a slow product cannot leave the page looking empty. */
    Promise.all(
      handles.map(function (handle) {
        return fetchCard(handle).then(
          function (card) {
            return { handle: handle, card: card };
          },
          function (error) {
            return { handle: handle, gone: !!error.gone };
          }
        );
      })
    ).then(function (results) {
      var stale = results.filter(function (result) { return result.gone; });
      var cards = results.filter(function (result) { return result.card; });

      cards.forEach(function (result) {
        grid.appendChild(result.card);
      });

      running = false;

      /* Products that no longer exist drop out of the saved list. */
      if (stale.length) {
        var keep = Sloos.wishlist.read().filter(function (handle) {
          return !stale.some(function (result) { return result.handle === handle; });
        });
        Sloos.wishlist.write(keep);
        return;
      }

      /* Never leave the page blank with no explanation. */
      if (!cards.length) {
        grid.hidden = true;
        if (empty) empty.hidden = serverCards() > 0;
      }

      document.dispatchEvent(new CustomEvent('sloos:wishlist:paint'));
    });
  }

  document.addEventListener('sloos:wishlist:change', render);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
